<template>

  <div class="modal " id="dialogBoxModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <div class="modal-content border border-warning">
      <div class="modal-header bg-warning border border-warning rounded">       
        <h4 class="modal-title"><strong>
          
          <i style="color:black" class="fas fa-exclamation mr-3" aria-hidden="true"></i>  
          
          {{ props.title }}</strong> </h4>
       
      </div>
      <div class="modal-body">
        <p style="font-size: 22px;">            
            <!--<i v-if="props.msg" style="color:blue;font-size:24px" class="fas fa-exclamation-circle mr-3" aria-hidden="true"></i> -->
           <strong> {{ props.msg }}</strong>
            </p>
      </div>
      <div class="modal-footer">
        <button ref="btnClose" type="button" @click="closeModal()" class="btn btn-primary">CHIUDI</button>        
      </div>
    </div>
  </div>
  </div>
  
</template>
<script>
    
export default {
  props : ['props'],
  
  created: function()
  {
    this.$nextTick(()  => {                  
        $('#dialogBoxModal').modal('show')
        this.$refs.btnClose.focus()
    
    })  
  },

  methods :
  {
  closeModal()
  {

  $('#dialogBoxModal').modal('hide')
  this.$nextTick(()  => {
      if(this.props.doSomeThing)   
      {
        this.props.method()  
      }
      this.$emit('close')        
    })    
  },      
  }
}
</script>    
<style scoped>
h4{
  font-size: 20px;
}
</style>
